import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import styled from "styled-components";

const AppWrapper = styled.div`
  width: "100%";
  height: "100%";
  top: 0;
  left: 0;
  background: "#ccc";
  z-index: 9999;
  overflow: "visible";
`;

const root = document.getElementById("root");
if (!root) {
  const root = document.createElement("div");
  root.id = "root";
  root.className = "row";
  document.getElementById("main-content")?.prepend(root);
}

ReactDOM.render(
  <React.StrictMode>
    <AppWrapper>
      <App />
    </AppWrapper>
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
